import { POST_TYPE } from "../data"
import { authStateVar } from "../data/authentication"
import { getNavigateToLink } from "./useJobUtils"

const KEY = "op_recent"
const MAX_ITEMS = 5

// Handle different storage keys for different users on the same device
const getStorageKey = () => {
  const authState = authStateVar()
  const userID = authState?.principal?.userID
  return userID ? `op_${userID}_recent` : KEY
}

// We also check this in the dashboard to decide whether to expand the Recently Viewed list
export function getRecentItems() {
  try {
    const storageKey = getStorageKey()
    return JSON.parse(localStorage.getItem(storageKey)) || []
  } catch {
    return []
  }
}

function getData(item) {
  if (!item.__typename) return null

  if (item.__typename === "Job") {
    return {
      id: item.id,
      type: "job",
      title: item.process?.name,
      description: item.repeat?.type,
      link: getNavigateToLink(item)
    }
  }

  if (item.__typename === "UserTrainingCourseDetail") {
    return {
      id: item.id,
      type: "training",
      title: item.course?.name,
      description: item.__typename,
      link: `/training/courses/${item.id}`
    }
  }

  if (item.__typename === "Action") {
    return {
      id: item.id,
      type: "action",
      title: item.title,
      description: item.author?.fullName,
      link: `/hub/action/${item.id}`
    }
  }

  if (item.__typename === "Workflow") {
    return {
      id: item.id,
      type: "incident",
      title: item.name,
      description: item.author?.fullName,
      link: `/hazards-incidents/report/${item.id}`
    }
  }

  if (item.__typename === "Post") {
    return {
      id: item.id,
      type: item.type === POST_TYPE.CAMPAIGN ? "campaign" : "post",
      title: item.title,
      description: item.author?.fullName,
      link: item.type === POST_TYPE.CAMPAIGN ? `/hub/campaign/${item.id}` : `/hub/post/${item.id}`
    }
  }

  if (item.__typename === "KnowledgeArticle") {
    return {
      id: item.id,
      type: "knowledge",
      title: item.title,
      description: item.__typename,
      link: `/knowledge/article/${item.id}`
    }
  }

  return null
}

export function addRecentItem(item) {
  try {
    const current = getRecentItems()

    // Strip out just what we need to store in the local storage - makes it easier to just pass through the whole objects (job, action, report etc...) from where it's being set. If more items are added to the recently viewed list, these cases below will need to be updated
    const storedItem = getData(item)
    if (!storedItem) return current

    // Remove any duplicates
    const filtered = current.filter((i) => i.id !== item.id)

    //  Stick it at the top of the pile
    const updated = [{ ...storedItem, visitedAt: Date.now() }, ...filtered].slice(0, MAX_ITEMS)

    const storageKey = getStorageKey()
    localStorage.setItem(storageKey, JSON.stringify(updated))

    return updated
  } catch {
    return getRecentItems()
  }
}
